const messages = {
  bonus: {
    title: "Boonuskrediitide ülevaade",
    description: "Eurodes boonus määratakse osalevatele ettevõtetele esitatud müügiandmete põhjal.",
    lastMonth: "Eelmine kuu",
    currentMonth: "Käesolev kuu",
    totalCurrentYear: "Kokku käesoleval aastal",
    totalLastYear: "Kokku eelmisel aastal",
  },
  points: {
    title: "Punktikrediitide ülevaade",
    period: "Käesolev kalendriaasta ({year})",
    totalAwarded: "Kokku antud punkte",
    redeemed: "Lunastatud punktid",
    totalBalance: "Punktide kogusaldo",
    redemptionRate: "Lunastatud punktid protsendina antud punktidest",
    averageAwarded: "Keskmiselt antud punktid ostetud rehvi kohta",
    standardAwarded: "Netopunktid arvutatud müügiridadelt, sh tagastused",
    bsPlusInclBooster: "Punktid positiivse kogusega müügiridadelt",
    perTire: "Lunastatud punktid ostetud rehvi kohta",
  },
  tires: {
    title: "Rehvikoguse ülevaade",
    description: "Klientide ostetud rehvid",
    prevMonth: "Eelmine kuu",
    totalLastYear: "Kokku eelmisel aastal",
    purchaseIndirect: "Ost hulgimüüja kaudu (kaudne)",
    purchaseDirect: "Ost hulgimüüja kaudu (otsene)",
    totalCurrentYear: "Kokku käesoleval aastal",
    currentMonth: "Käesolev kuu",
  },
  participating: {
    title: "Osalevate klientide ülevaade",
    description: "BRIDGESTONE PLUS-is registreerunud ettevõtteid saab siduda kliendinumbri kaudu.",
    total: "Kokku",
    newThisMonth: "Uued sel kuul",
    newThisYear: "Uued sel aastal",
    createdInCurrentMonth: "Loodud käesoleval kuul (admini poolt)",
    loginsCurrentYear: "Sisselogimised käesoleval aastal (pärast tingimuste aktsepteerimist)",
  },
  brand: {
    title: "Bränd",
    description: "Teie ostud detailides",
    centerTitle: "Brändi\nkaupa",
  },
  rim: {
    title: "Velg",
    centerTitle: "Velje suuruse\nkaupa",
  },
  tireGoals: {
    title: "Rehvieesmärgid",
    subtitle: "Teenige punkte rehviostude eest.",
    centerTitle: "Rehvi suuruse\nkaupa",
    tiresRemaining: "Järelejäänud rehvid",
    progressionTarget: "Edenemise eesmärk: ",
    pointsEarnedPurchases: "teenitud punktid\n" + "teie\n" + "ostudelt",
    pointsEarnedBoosters: "teenitud punktid\n" + "boosteritelt",
    purchasesDetail: "Teie ostud detailides",
    cta: "Lugege rohkem oma punktide kohta",
    pointsTitle: "Teie punktid",
    pointsSubtitle: "Bridgestone'i ostudelt teenitud punktid",
    achievementsTitle: "Teie saavutused",
    achievementsSubtitle: "Teie aastane kohustus:",
    achievementsSubtitle2: "rehvi",
  },
  score: {
    title: "Skoor",
    total: "Kokku",
    credits: "Krediidid",
    deductions: "Mahaarvamised",
        unlockedPoints: "Avatud punktid",
        pendingPoints: "Ootel punktid",
  },
  score_extended: {
    title1: "Punktisaldo",
    title2: "Boonus eurodes",
    balance: "Punktisaldo",
    bonus_in_euro: "Boonus eurodes",
    date: "Kuupäev",
    added_points: "Lisatud punktid",
    total_bands: "Brände kokku",
    goal: "Eesmärk",
    tyres_previous_year: "Eelmisel aastal müüdud rehvid",
    tyres_current_year: "Sel aastal müüdud rehvid",
    target_this_year: "Selle aasta müügieesmärk",
    bonus_this_year: "Teenitud boonus (€)",
    loyal_minimum: "Minimaalne lojaalsustase",
    bonus_multiplier: "Boonuse kordaja",
  },
  lastImport: {
    label: "Viimane müügiandmete import:",
    on: "",
  },
  wholesalerTable: {
    title: "Osalevad kliendid detailides",
    description: "Allpool leiate ettevõtted, kes on registreerunud BRIDGESTONE PLUS-i teie ettevõtte kliendinumbriga. Klientide leidmiseks saate kasutada filtreid või otsingut.",
    columns: {
      customer_number: "Kliendi nr",
      address_company_name: "Ettevõte",
      address_street: "Tänav ja majanumber",
      address_postal_code: "Postiindeks",
      address_city: "Linn",
      last_registration: "Viimane registreerimine",
      network: "Võrgustik",
      profile_group: "Grupp",
      tires_amount: "Rehvide arv",
      point_balance: "Punktisaldo",
      bonus: "Boonus",
      details: "Detailid",
    },
    searchPlaceholder: "Otsi",
  },
  dealerTable: {
    columns: {
      date: "Kuupäev",
      wholesaler_bs_plus: "Hulgimüüja BS+",
      customer_number: "Kliendinumber",
      article: "Artikkel",
      brand: "Bränd",
      product: "Toode",
      type: "Tüüp",
      inch: "Toll",
      season: "Hooaeg",
      amount: "Kogus",
      points: "Punktid",
      activity: "Tegevus",
      total_points: "Punkte kokku",
    },
    title: "Diilerite tabel",
    description: "Diilerite tegevuste ülevaade",
  },
  business_units: {
    title: "Äriüksused",
    centerTitle: "Üksuse\nkaupa",
  },
  season: {
    title: "Hooaeg",
    centerTitle: "Aastaaja\nkaupa",
  },
};

export default {
  messages,
};
